import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { layout, primitive, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.container, isDesktop && styles.containerDesktop, style],
  });
};

export const DaypartHoursText = withTypography({
  variant: 'copyOne',
});

export const SunriseIcon = Icon.withConfig({
  variant: 'bkSunrise',
  marginRight: '$2',
});

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: primitive.$white,
    borderBottomColor: primitive.$greyFour,
    borderBottomWidth: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    padding: spacing.$3,
    width: layout.full,
  },
  containerDesktop: {
    borderBottomWidth: 0,
    marginHorizontal: spacing.$3,
  },
});
